import config from 'config'

const urls = {
  single: 'user',
  multiple: 'users',
}

export default {
  resourceUrl: `${config.resourceHost}user`,
  findCity: `${config.resourceHost}find/city/`,
  fetchDefaultusersModelUrl: `${config.resourceHost}users/new`,
  userListSettingUrl: `${config.resourceHost}setting/userlist/user`,

  clientUrl: urls,

  options: {
    list: {
      name: urls.single,
      quickfilters: {
        models: [
          { name: 'all', title: 'Alle' },
        ],
      },
      defaultSort: { property: 'lastName', desc: false },
    },
  },
}
